<div class="card" *ngIf="menuOption">
  <h5>{{menuOption.Id?'Edit':'New'}} Menu Option</h5>
  <div class="p-fluid tw-max-w-lg flex flex-column">
    <div class="field">
      <label htmlFor="name">Name</label>
      <input pInputText id="name" type="text" [(ngModel)]="menuOption.Name" />
    </div>

    <div class="field">
      <label>Type</label>
      <p-dropdown [options]="types" [(ngModel)]="menuOption.Type"></p-dropdown>
    </div>

    <div class="field">
      <label>Price</label>
      <input pInputText type="number" [(ngModel)]="menuOption.Price" />
    </div>

    <div class="field">
      <label for="tags">Tags</label>
      <brt-tag-selector id="tags" [(ngModel)]="menuOption.Tags" [businessId]="menuOption.BusinessId"
        [canAdd]="true"></brt-tag-selector>
    </div>

    <div class="field">
      <p-fieldset legend="UI Settings" [toggleable]="true" [collapsed]="true">
        <brt-ui-settings id="ui" [(ngModel)]="menuOption.UI" [business-id]="businessId"
          [keys]="['Image:image','Description:text']">
        </brt-ui-settings>
      </p-fieldset>
    </div>
  </div>
  <div class="tw-flex tw-gap-2">
    <button pButton pRipple label="Save" (click)="save()"></button>
    <button *ngIf="menuOption.Id" pButton pRipple label="Apply" class="p-button-secondary"
      (click)="save(false)"></button>
  </div>

  <brt-menu-option-list></brt-menu-option-list>
</div>